
import { defineComponent, reactive } from "vue";

type Props = {
  signupPath: string,
  signinPath: string
};

interface State {
  visible: boolean
}

export default defineComponent({
  name: "VisitorModal",
  props: {
    signupPath: {
      type: String,
      default: ""
    },
    signinPath: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const state = reactive<State>({
      visible: false
    });
    const open = () => {
      state.visible = true;
    };
    const close = (e) => {
      if (e.target.className === "modal modal-overlay") {
        state.visible = false;
      }
    };
    return {
      props,
      state,
      open,
      close
    };
  }
});
